import request from '@/system/engine/request';
import config from '@/system/engine/config';
import {getLocalStorage} from '@/system/store/localstorage';

// center
export function centerAjaxTable(){
	const data = request({
		url: config.url+'developer/center',
		method: 'get'
	});

	return Promise.resolve(data);
}

export function updateMemberPermission(postData){
	const data = request({
		url: config.url+'developer/updatePermission',
		method: 'post',
        data: postData
	});

	return Promise.resolve(data);
}

export function updateAdminPermission(postData){
	const data = request({
		url: config.url+'developer/updatePermission',
		method: 'post',
        data: postData
	});

	return Promise.resolve(data);
}

export function reRunMethod(postData){
	const data = request({
		url: config.url+'developer/rerun',
		method: 'post',
        data: postData
	});

	return Promise.resolve(data);
}